import React, { useState, useEffect } from 'react'
import './index.css'
import { AxiosResponse } from "axios";
import api from '../../Services/api'
import ModalAlert from '../ModalAlert/modal'
import secureLocalStorage from "react-secure-storage";
import Loading from '../Loading';
import { useNavigate } from 'react-router';
import Select from 'react-select'
import CustomRegistrationModalShell from '../CustomRegistrationForm/CustomRegistrationModalShell'
import ActiveToggleField from '../CustomRegistrationForm/ActiveToggleField'
import '../CustomRegistrationForm/custom-registration-modal.css'
import '../TaskForm/usuario-form.css'
import '../TaskForm/planner-form-fields.css'

function FormTipoCorretiva(props: any) {

    const navigate = useNavigate();
    const dadosFab = (sessionStorage.getItem("dadosFab") || '{}');
    let userFab = JSON.parse(dadosFab);
    const [id, setId] = useState(userFab.crt_id || '')
    const [active, setActive] = useState(userFab.crt_active != undefined ? Boolean(userFab.crt_active) : true)
    const [description, setDescription] = useState(userFab.crt_description || '')
    const [alternativeIdentifier, setAlternativeIdentifier] = useState(userFab.crt_alternativeidentifier || '')
    const [descriptionIni, setDescriptionIni] = useState(userFab.crt_description || '')
    const [alternativeIdentifierIni, setAlternativeIdentifierIni] = useState(userFab.crt_alternativeidentifier || '')
    const [entidade, setEntidade] = useState(String(userFab.ett_id || ''))

    
    const [openModal, setOpenModal] = useState(false)
    const [qualAlert, setQualAlert] = useState(<></>)

    const [optionsCorretiva, setOptionsCorretiva] = useState([])
    const [optionsEntidade, setOptionsEntidade] = useState([])

    useEffect(() => {

        validatToken();
       
    }, []);


    async function validatToken() {

        let ret: AxiosResponse;
        let valor: any;

        const _user = secureLocalStorage.getItem('t')

        api.defaults.headers.common['Authorization'] = _user as ''

        try {

            ret = await api.get("/status/validar")

            if (ret.data.status === 200) {

                secureLocalStorage.setItem('t', ret.data.data);
                secureLocalStorage.setItem('acp', ret.data.decodedToken.acp_integrationid);
                secureLocalStorage.setItem('n', ret.data.decodedToken.name);
                secureLocalStorage.setItem('iag', ret.data.decodedToken.id);
                secureLocalStorage.setItem('cy', ret.data.decodedToken.company);

              await  GetTipoCorretiva()
              await   GetTipoEntidade();
            }
        } catch (e: any) {

            if (e.response.data.status === 403) {

                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Token inválido ou expirado!</span></div>
                    <div className='btn-alert' onClick={fecharModalToken}><span className="btn-alert-lab">OK</span></div>
                </div>)

                setOpenModal(true)

            }
        }

    }

    async function GetTipoEntidade() {
        let ret: AxiosResponse;
        let valor: any;

        try {
            ret = await api.get("entitytype/listar")
            if (ret.data.status === 200) {
                valor = ret.data.data;

                const arr = [] as any;
                let result = valor;
                result.map((user: any) => {
                    return arr.push({ value: String(user.ett_id), label: user.ett_description });
                });
                
                setOptionsEntidade(arr)

            }
        } catch (e) {
            setOptionsEntidade([])

        }
    }

    async function GetTipoCorretiva() {
        let ret: AxiosResponse;
        let valor: any;

        try {
            ret = await api.get("correctivetype/listar")
            if (ret.data.status === 200) {
                valor = ret.data.data;

                setOptionsCorretiva(valor)

            }
        } catch (e) {
            setOptionsCorretiva([])

        }
    }

    function fecharModalToken() {

        secureLocalStorage.removeItem('t')
        secureLocalStorage.removeItem('acp')
        secureLocalStorage.removeItem('n')
        secureLocalStorage.removeItem('iag')
        navigate('/login');
        setOpenModal(false)

    }

    function ConfirmarContrato() {

        if (id === undefined || id === '') {
            insertContrato();
        } else {
            UpdateContrato();
        }
    }


    function fecharModal() {
        setOpenModal(false)
    }

    async function UpdateContrato() {



        const FiltrarDescricao = optionsCorretiva.filter(
            (e: any) => {
                return e.crt_description.toLowerCase() === description.toLowerCase()
            }
        );

        const FiltrarAlternativeIdentifier = optionsCorretiva.filter(
            (e: any) => {
                return e.crt_alternativeidentifier.toLowerCase() === alternativeIdentifier.toLowerCase()
            }
        );


        if (descriptionIni.toLowerCase() !== description.toLowerCase() && FiltrarDescricao.length > 0) {

            setQualAlert(<div className='div-alert'>
                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                <div className='div-info-alert'><span className="info-alert">Descrição já está em uso.</span></div>
                <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
        } else
            if (description === "") {
                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
                    <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                </div>)
                setOpenModal(true)
            } else
                if (alternativeIdentifier === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Digite o identificador alternativo.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                } else if (alternativeIdentifierIni.toLowerCase() !== alternativeIdentifier.toLowerCase() && FiltrarAlternativeIdentifier.length > 0) {

                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Identificador alternativo já está em uso.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                }else
                if (entidade === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Selecione o tipo de entidade.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                }
                else {

                    let ret: AxiosResponse;
                    const dados = {
                        crt_id: id,
                        crt_active: active,
                        crt_description: description,
                        crt_alternativeidentifier: alternativeIdentifier,
                        ett_id: entidade,
                    }
                
                    try {
                        ret = await api.put("correctivetype/update", {
                            data: dados,
                        });
                        if (ret.data.status === 200) {
                            props.voltar()
                        }
                    } catch (e: any) {
                        setQualAlert(<div className='div-alert'>
                            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                            <div className='div-info-alert'><span className="info-alert">Não foi possível concluir a alteração.</span></div>
                            <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                        </div>)
                    setOpenModal(true)
                    }
                }

    }

    async function insertContrato() {
        let ret: AxiosResponse;


        const FiltrarDescricao = optionsCorretiva.filter(
            (e: any) => {
                return e.crt_description.toLowerCase() === description.toLowerCase()
            }
        );

        const FiltrarAlternativeIdentifier = optionsCorretiva.filter(
            (e: any) => {
                return e.crt_alternativeidentifier.toLowerCase() === alternativeIdentifier.toLowerCase()
            }
        );


        if (FiltrarDescricao.length > 0) {

            setQualAlert(<div className='div-alert'>
                <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                <div className='div-info-alert'><span className="info-alert">Descrição já está em uso.</span></div>
                <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
            </div>)
            setOpenModal(true)
        } else
            if (description === "") {
                setQualAlert(<div className='div-alert'>
                    <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                    <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                    <div className='div-info-alert'><span className="info-alert">Digite a descrição.</span></div>
                    <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                </div>)
                setOpenModal(true)
            } else
                if (alternativeIdentifier === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Digite o identificador alternativo.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                } else if (FiltrarAlternativeIdentifier.length > 0) {

                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Identificador alternativo já está em uso.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                }else
                if (entidade === "") {
                    setQualAlert(<div className='div-alert'>
                        <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                        <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                        <div className='div-info-alert'><span className="info-alert">Selecione o tipo de entidade.</span></div>
                        <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                    </div>)
                    setOpenModal(true)
                }

                else {
                    const dados = [{
                        crt_active: active,
                        crt_description: description,
                        crt_alternativeidentifier: alternativeIdentifier,
                        ett_id: entidade, 
                    }]

                    try {
                        ret = await api.post("correctivetype/insert", {
                            data: dados,
                        });

                        if (ret.data.status === 200) {
                            props.voltar()
                        }
                    } catch (e: any) {
                        setQualAlert(<div className='div-alert'>
                            <span className="fa-regular fa-circle-xmark ControleIconAlertcancel"></span>
                            <div className='div-info-alert-atencao'><span className="info-alert-atencao">ATENÇÃO</span></div>
                            <div className='div-info-alert'><span className="info-alert">Não foi possivel concluir o cadastramento.</span></div>
                            <div className='btn-alert' onClick={fecharModal}><span className="btn-alert-lab">OK</span></div>
                        </div>)

                        setOpenModal(true)
                    }
                }
    }

    function ValitarActive() {
        let e = document.getElementById("checkbox-active-fab") as HTMLInputElement;

        if (e.checked) {

            setActive(true)
        } else {

            setActive(false)
        }
    }

    function voltar() {

        props.voltar();

    }

    const customStyles = {
        control: (provided:any, state:any) => ({
          ...provided,
          background: '#fff',
          minHeight: '30px',
          height: '30px',
          borderColor: state.isFocused ? 'grey' : '#92989e',
          
        }),
        
    
        valueContainer: (provided:any, state:any) => ({
          ...provided,
          height: '30px',
          padding: '0 6px'
        }),
    
        input: (provided:any, state:any) => ({
          ...provided,
          margin: '0px',
          fontSize: 14,
          
        }),
        indicatorsContainer: (provided:any, state:any) => ({
          ...provided,
          height: '30px',
        }),
      };						


    return (
        <>
            <CustomRegistrationModalShell
                mode={id ? 'edit' : 'add'}
                recordId={id ? String(id) : undefined}
                title={id ? 'Editar Tipo Corretiva' : 'Cadastrar Tipo Corretiva'}
                subtitle="Tipo de manutenção corretiva vinculado à entidade do cadastro."
                onCancel={props.voltar}
                onSave={ConfirmarContrato}
            >
                <div className="planner-form-fields">
                    <ActiveToggleField active={active} onChange={setActive} />

                    <div className="usuario-form__grid usuario-form__grid--2">
                        <div className="usuario-form__field">
                            <label className="usuario-form__label usuario-form__label--required">Descrição</label>
                            <input
                                className="usuario-form__input"
                                autoComplete="off"
                                type="text"
                                onChange={(e) => setDescription(e.target.value)}
                                value={description}
                            />
                        </div>
                        <div className="usuario-form__field">
                            <label className="usuario-form__label usuario-form__label--required">
                                Identificador Alternativo
                            </label>
                            <input
                                className="usuario-form__input"
                                autoComplete="off"
                                type="text"
                                onChange={(e) => setAlternativeIdentifier(e.target.value)}
                                value={alternativeIdentifier}
                            />
                        </div>
                    </div>

                    <div className="usuario-form__field">
                        <label className="usuario-form__label usuario-form__label--required">Tipo de Entidade</label>
                        <div className="usuario-form__select-wrap">
                            <Select
                                maxMenuHeight={200}
                                placeholder={'Selecione...'}
                                options={optionsEntidade}
                                styles={customStyles}
                                value={optionsEntidade.filter(function (option: any) {
                                    return option.value === entidade;
                                })}
                                onChange={(options: any) =>
                                    !options ? setEntidade("") : setEntidade(options.value)
                                }
                                isClearable
                                noOptionsMessage={() => "Não encontrado..."}
                                theme={(theme: any) => ({
                                    ...theme,
                                    borderRadius: 8,
                                    colors: {
                                        ...theme.colors,
                                        primary25: '#eef2ff',
                                        primary: '#3962ac',
                                    },
                                })}
                            />
                        </div>
                    </div>
                </div>
            </CustomRegistrationModalShell>

            <ModalAlert isOpen={openModal} setModalOpen={() => setOpenModal(!openModal)}>
                <div className='container-modal-alert'>
                    {qualAlert}
                </div>
            </ModalAlert>
        </>
    );

}

export default FormTipoCorretiva;